{
  "Accessibility menu": "የተደራሽነት ምናሌ",
  "Close": "ዝጋ",
  "Content adjustments": "የይዘት ማስተካከያዎች",
  "Navigation adjustments": "የአደራዳሪ ማስተካከያዎች",
  "Align Left": "ግራ አሰላልል",
  "Adjust Font Size": "የፊደል መጠን አስተካክል",
  "Highlight Title": "ርዕስ አጉልተው አሳይ",
  "Highlight Links": "አገናኞችን አጉልተው አሳይ",
  "Readable Font": "ለመንበብ ቀላል ፊደል",
  "Colour adjustments": "የቀለም ማስተካከያዎች",
  "Dark Contrast": "ጨለማ ንጽጽር",
  "Light Contrast": "ብርሃናዊ ንጽጽር",
  "High Contrast": "ከፍተኛ ንጽጽር",
  "High Saturation": "ከፍተኛ ብልጭታ",
  "Low Saturation": "ዝቅተኛ ብልጭታ",
  "Monochrome": "ነጠላ ቀለም",
  "Tools": "መሳሪያዎች",
  "Reading Guide": "የንባብ መመሪያ",
  "Big Cursor": "ትልልቅ አምሳያ",
  "Increase Font Size": "የፊደል መጠን ጨምር",
  "Decrease Font Size": "የፊደል መጠን አሳንስ",
  "Letter Spacing": "የፊደል ክፍተት",
  "Line Height": "የመስመር ቁመት",
  "Font Weight": "የፊደል ውፍረት",
  "Dyslexia Font": "የዲስሌክሲያ ፊደል",
  "Language": "ቋንቋ",
  "Accessibility widget": "የተደራሽነት ምናሌን ክፈት",
  "Accessibility Profiles": "የተደራሽነት መገለጫዎች",
  "Cognitive Disability": "የአእምሮ አካል ጉድለት",
  "Seizure Safe": "የምታንስ የማይነካ",
  "Accessibility statement": "የተደራሽነት መግለጫ",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "አኒሜሽኖችን አቁም",
  "Reset all settings": "ቅንብሮችን ዳግም አስጀምር",
  "Shortcut:": "Shortcut:"
}
